import { AnonymousLayout } from '../components/layouts/anonymous'
import useTranslation from 'lib/i18n'
import { Result } from 'antd'

const Page404 = () => {
  const { t } = useTranslation()
  return (
    <AnonymousLayout>
      <Result title={t('page_not_found_title')} status={404} />
    </AnonymousLayout>
  )
}

export default Page404
